/* eslint-disable react/prop-types */
import React from "react";
import { useHistory } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import { trackJobMatchScoreClick } from "../../../../../utils/analytics";
import "./PostApplicationMatchScoreModal.scss";

const PostApplicationMatchScoreModal = ({ open, onClose, onRedirect }) => {
  const history = useHistory();

  const handleActionClick = () => {
    trackJobMatchScoreClick({ source: "post_application_modal" });
    if (onRedirect) {
      onRedirect();
    } else {
      if (onClose) onClose();
      history.push("/job-match-score");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="post-application-match-score-title"
      aria-describedby="post-application-match-score-desc"
      style={{ zIndex: 1400 }}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(15, 23, 42, 0.65)",
          backdropFilter: "blur(2px)",
        },
      }}
      PaperProps={{
        className: "pams-dialog-paper",
        style: {
          width: "100%",
          maxWidth: "460px",
          borderRadius: "24px",
          padding: "32px 36px 36px",
          backgroundColor: "#ffffff",
          boxShadow: "0 25px 60px -15px rgba(0, 0, 0, 0.25)",
          overflow: "hidden",
          boxSizing: "border-box",
          margin: "16px",
        },
      }}
    >
      <div
        className="pams-modal-container"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {/* Top bar with Badge and Close button */}
        <div
          className="pams-top-bar"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <span
            className="pams-badge"
            style={{
              display: "inline-flex",
              alignItems: "center",
              backgroundColor: "#ebf3ff",
              color: "#1e5cd9",
              fontSize: "12px",
              fontWeight: 800,
              letterSpacing: "0.6px",
              textTransform: "uppercase",
              padding: "6px 14px",
              borderRadius: "9999px",
              lineHeight: 1,
            }}
          >
            AI MATCH SCORE
          </span>
          <button
            type="button"
            className="pams-close-btn"
            onClick={onClose}
            aria-label="Close dialog"
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              padding: "4px",
              borderRadius: "50%",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#8c96a3",
              lineHeight: 1,
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Title */}
        <h2
          id="post-application-match-score-title"
          className="pams-title"
          style={{
            fontSize: "30px",
            fontWeight: 800,
            color: "#0f172a",
            lineHeight: 1.2,
            margin: "0 0 16px 0",
            letterSpacing: "-0.5px",
          }}
        >
          Applying on other platforms too?
        </h2>

        {/* Description */}
        <p
          id="post-application-match-score-desc"
          className="pams-description"
          style={{
            fontSize: "15px",
            color: "#475569",
            lineHeight: 1.55,
            margin: "0 0 28px 0",
            fontWeight: 400,
          }}
        >
          Check your match score for any job outside Workbrook. Paste the job URL or description and we will analyse your fit in seconds.
        </p>

        {/* Action Button */}
        <button
          type="button"
          className="pams-action-btn"
          onClick={handleActionClick}
          style={{
            width: "100%",
            height: "52px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            backgroundColor: "#1e5cd9",
            color: "#ffffff",
            fontSize: "16px",
            fontWeight: 600,
            padding: "0 20px",
            border: "none",
            borderRadius: "12px",
            cursor: "pointer",
            boxSizing: "border-box",
            textDecoration: "none",
          }}
        >
          <span>Check my match score</span>
          <span
            className="pams-arrow-icon"
            aria-hidden="true"
            style={{
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.167 10h11.666M11 5.5l4.5 4.5-4.5 4.5"
                stroke="#ffffff"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </button>
      </div>
    </Dialog>
  );
};

export default PostApplicationMatchScoreModal;
